module.exports = __webpack_public_path__ + "fonts/roboto-v30-latin-regular.15d9f621.woff2";